
































































import { Component } from 'vue-property-decorator';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import { InstitutionAccountSettingsModule } from '@/store/Accounts/InstitutionAccountSettingsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ThirdPartyAccountDetails from '@/components/Accounts/ThirdPartyAccounts/ThirdPartyAccountDetails.vue';
import ThirdPartyAccountTransactions from '@/components/Accounts/ThirdPartyAccounts/ThirdPartyAccountTransactions.vue';
import PaymentOrders from '@/components/Accounts/Shared/PaymentOrders/PaymentOrders.vue';
import Payments from '@/components/Accounts/Shared/Payments/Payments.vue';
import Payees from '@/components/Accounts/Shared/Payees/Payees.vue';
import InstitutionAccountSettings from '@/components/Accounts/InstitutionAccounts/Settings/InstitutionAccountSettings.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'ThirdPartyAccount', components: { Alert, ThirdPartyAccountDetails, ThirdPartyAccountTransactions, PaymentOrders, Payments, Payees, InstitutionAccountSettings }, metaInfo: { title: 'Accounts' } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await InstitutionAccountModule.getThirdPartyAccount(this.$route.params.id);
        await InstitutionAccountSettingsModule.getInstitutionalAccountSettings(this.$route.params.id);
    }

    get labels() {
        return AuthModule.me.institution.config.labels;
    }

    get account() {
        return InstitutionAccountModule.thirdPartyAccount;
    }

    get loading() {
        return InstitutionAccountModule.loadingThirdPartyAccount;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
